import { Base } from "@/atoms-react/text/Text.react.tsx";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react.tsx";
import { useTranslation } from "react-i18next";
import Loader from "@/atoms-react/loader/Loader.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react";
import type { bronzeCategories } from "@/features/user/quiz/types";
import { useState } from "react";
import { usei18n } from "@/features/utils/hooks/use-i18n";

export const MovableIncomes = ({
  setFormResponseMI,
  mouvableIncomes,
  setFormResponseOSIComment,
  sourceIncomeItems,
  isLoadingSourcesIncome,
  commentProps
}: {
  setFormResponseMI: (mouvableIncomes: bronzeCategories, isChecked: boolean) => void;
  mouvableIncomes: string[];
  setFormResponseOSIComment: (comment: string, valueChecked: boolean) => void;
  sourceIncomeItems: bronzeCategories[];
  isLoadingSourcesIncome: boolean;
  commentProps: string | null;
}) => {
  const { t } = useTranslation(["pass"]);
  const codeOfOtherIncome = sourceIncomeItems?.find((item) => item.code === 10);
  const [comment, setComment] = useState<string | null>(commentProps);
  const { getLanguage } = usei18n();

  const handleCommentChange = (value: string) => {
    setComment(value);
    setFormResponseOSIComment(
      value,
      mouvableIncomes.includes(codeOfOtherIncome?.code.toString() as string)
    );
  };

  const handleCheckboxChange = (mouvableIncome: bronzeCategories, isChecked: boolean) => {
    setFormResponseMI(mouvableIncome, isChecked);
  };

  return (
    <>
      {isLoadingSourcesIncome && (
        <div className="mt-4 mb-4 flex flex-1 items-center justify-center">
          <Loader className="text-gray-500" />
        </div>
      )}
      {!isLoadingSourcesIncome && (
        <div className="flex w-full flex-col" data-cy="other-real-estate-assets">
          <div className="my-4 mt-4 grid grid-cols-1 gap-2 md:grid-cols-2">
            {sourceIncomeItems &&
              [...sourceIncomeItems.filter((s) => s.code !== 10), codeOfOtherIncome].map((c) => (
                <Checkbox
                  key={c?.id}
                  value={
                    mouvableIncomes &&
                    mouvableIncomes.some((income) => Number(income) === Number(c?.code))
                  }
                  onChange={(value) => handleCheckboxChange(c as bronzeCategories, value)}
                >
                  <Base className="mb-1 cursor-pointer">
                    {getLanguage() === "fr" ? c?.name : c?.english_name}
                  </Base>
                </Checkbox>
              ))}
          </div>
          {mouvableIncomes &&
            codeOfOtherIncome &&
            mouvableIncomes!.includes(codeOfOtherIncome?.code.toString()) && (
              <div className={"mt-4 mb-4"}>
                <InputLabel
                  onChange={(value: string) => handleCommentChange(value)}
                  value={comment as string}
                  className="mb-1 w-full flex-1 md:mb-0"
                  placeholder={t(
                    "olkypass.mainPage.olkypass.BronzeForms.other_real_estate_placeholder"
                  )}
                />
              </div>
            )}
        </div>
      )}
    </>
  );
};
